import React, { memo } from 'react';

const DOT_DELAY_1 = { animationDelay: '0ms' };
const DOT_DELAY_2 = { animationDelay: '150ms' };
const DOT_DELAY_3 = { animationDelay: '300ms' };

/**
 * A component that displays a typing indicator for messaging
 * 
 * @param {Object} props - Component props
 * @param {boolean} props.isTyping - Whether the recipient is typing
 * @param {string} props.recipientName - Name of the person typing
 */
const TypingIndicator = memo(({ isTyping, recipientName }) => {
  if (!isTyping) return null;
  
  return (
    <div className="flex items-center text-gray-500 text-sm mb-2 pl-4">
      <div className="mr-2">
        <span className="inline-block">{recipientName} is typing</span>
      </div>
      <div className="flex space-x-1">
        <div className="w-1.5 h-1.5 bg-gray-400 rounded-full animate-bounce" style={DOT_DELAY_1}></div>
        <div className="w-1.5 h-1.5 bg-gray-400 rounded-full animate-bounce" style={DOT_DELAY_2}></div>
        <div className="w-1.5 h-1.5 bg-gray-400 rounded-full animate-bounce" style={DOT_DELAY_3}></div>
      </div>
    </div>
  );
});

TypingIndicator.displayName = 'TypingIndicator';

export default TypingIndicator;
